export const storeOverviewTranslations = {
  storeOverviewTitle: {
    key: 'storeOverview.storeOverviewTitle',
    defaultValue: 'Sales Overview',
  },
  indexFilterLabel: {
    key: 'storeOverview.indexFilterLabel',
    defaultValue: 'Index',
  },
  numbers: {
    key: 'storeOverview.numbers',
    defaultValue: 'Numbers',
  },
  subIndexLabel: {
    key: 'storeOverview.subIndexLabel',
    defaultValue: 'Sub Index',
  },
  garmentGroupLabel: {
    key: 'storeOverview.garmentGroupLabel',
    defaultValue: 'Garment Group',
  },
  departmentLabel: {
    key: 'storeOverview.departmentLabel',
    defaultValue: 'Department',
  },
  salesNetThisYear: {
    key: 'storeOverview.salesNetThisYear',
    defaultValue: 'Sales Net TY',
  },
  noDataFilterText: {
    key: 'storeOverview.noDataFilterText',
    defaultValue: 'No data found for selected filters',
  },
  changeFilterText: {
    key: 'storeOverview.changeFilterText',
    defaultValue: 'Try changing filters or switching chips to see more data!',
  },
  chipTooltips: {
    lastCompleteDay: {
      key: 'storeOverview.chipTooltips.lastCompleteDay',
      defaultValue: 'Selected day (adjusting to the date selector)',
    },
    currentWeek: {
      key: 'storeOverview.chipTooltips.currentWeek',
      defaultValue: 'The current week that you are in, based on the date selector.',
    },
    lastCompleteWeek: {
      key: 'storeOverview.chipTooltips.lastCompleteWeek',
      defaultValue: 'Last Complete Week (adjusting to the date selector)',
    },
    lastFourWeeks: {
      key: 'storeOverview.chipTooltips.lastFourWeeks',
      defaultValue: 'Last 4 completed weeks (adjusting to the date selector)',
    },
    accumulatedFinancialYearToDate: {
      key: 'storeOverview.chipTooltips.accumulatedFinancialYearToDate',
      defaultValue: 'Accumulated this fiscal year, starting date 1st of December.',
    },
  },
  headerTooltips: {
    vsLY: {
      key: 'storeOverview.headerTooltips.vsLY',
      defaultValue: 'Sales vs last year',
    },
    vsPL: {
      key: 'storeOverview.headerTooltips.vsPL',
      defaultValue: 'Sales vs Plan. Does not exist when Index is filtered',
    },
    vsBU: {
      key: 'storeOverview.headerTooltips.vsBU',
      defaultValue: 'Sales vs budget',
    },
    vsArea: {
      key: 'storeOverview.headerTooltips.vsArea',
      defaultValue:
        "The difference in the store's takt vs. the area it belongs to's takt, shown as an index. E.g. 110-takt vs LY for store, 100-takt vs LY for area = 110 takt vs. area",
    },
    vsSM: {
      key: 'storeOverview.headerTooltips.vsSM',
      defaultValue:
        "The difference in the store's takt vs. the Sales Market it belongs to takt, shown as an index. E.g. 110-takt vs LY for store, 100-takt vs LY for sales market = 110 takt vs. sales market",
    },
    mnyTY: {
      key: 'storeOverview.headerTooltips.mnyTY',
      defaultValue: 'The amount sold on the specified time horizon',
    },
    diffMny: {
      key: 'storeOverview.headerTooltips.diffMny',
      defaultValue: 'The difference in amount of money in selling vs. LY on the specified time horizon.​',
    },
    vsLLW: {
      key: 'storeOverview.headerTooltips.vsLLW',
      defaultValue: 'The difference between the last completed week and the week prior to that, shown as %',
    },
    fpTakt: {
      key: 'storeOverview.headerTooltips.fpTakt',
      defaultValue: 'Full-price takt - items sold without reduction and discount vs. LY',
    },
    reducedTakt: {
      key: 'storeOverview.headerTooltips.reducedTakt',
      defaultValue: 'Items sold with reduction or discount vs. LY',
    },
    traffic: {
      key: 'storeOverview.headerTooltips.traffic',
      defaultValue: 'The amount of visitors',
    },
    conversion: {
      key: 'storeOverview.headerTooltips.conversion',
      defaultValue: 'The amount of paying customers (receipts) over the amount of visitors',
    },
    ppr: {
      key: 'storeOverview.headerTooltips.ppr',
      defaultValue: 'Pieces per receipt - how many pcs were sold on average over all receipts',
    },
    pricePerPiece: {
      key: 'storeOverview.headerTooltips.pricePerPiece',
      defaultValue: 'The average price on the sum of all pieces sold.',
    },
    avgPurchase: {
      key: 'storeOverview.headerTooltips.avgPurchase',
      defaultValue: 'The average purchase on all receipts (pieces/receipts * price/pcs)',
    },
    visitor: {
      key: 'storeOverview.headerTooltips.visitor',
      defaultValue: 'The average revenue that you get for each visitor coming into the store',
    },
    salesNetTY: {
      key: 'storeOverview.headerTooltips.salesNetTY',
      defaultValue: 'Sales net amount this year',
    },
    sobPercent: {
      key: 'storeOverview.headerTooltips.sobPercent',
      defaultValue: 'The share of business of the index/Garment group of the total.',
    },
    drivingUnit: {
      key: 'storeOverview.headerTooltips.drivingUnit',
      defaultValue: 'Driving Units. How much in % the index/garment group is adding/draining to the total.',
    },
    netSale: {
      key: 'storeOverview.headerTooltips.netSale',
      defaultValue: 'The amount the product sold for last completed week',
    },
    pieces: {
      key: 'storeOverview.headerTooltips.pieces',
      defaultValue: 'The number of pieces the product sold last completed week',
    },
    price: {
      key: 'storeOverview.headerTooltips.price',
      defaultValue: 'The price of the product',
    },
    diffLLW: {
      key: 'storeOverview.headerTooltips.diffLLW',
      defaultValue: 'The difference in sales on that product last week compared to the week prior.',
    },
    rankingVsArea: {
      key: 'storeOverview.headerTooltips.rankingVsArea',
      defaultValue:
        'The ranking of the outcome of sales of that product in the store, vs the area. E.g. rank 4 in the store, and rank 2 in the area, will show -2.',
    },
    rankingVsSM: {
      key: 'storeOverview.headerTooltips.rankingVsSM',
      defaultValue:
        'The ranking of the outcome of sales of that product in the store, vs the sales market. E.g. rank 8 in the store, and rank 2 in the Sales Market, will show -6.',
    },
    potentialGain: {
      key: 'storeOverview.topPotential.potentialGain',
      defaultValue:
        'How much money you would gain if you sell in takt on par with the area. If your store is having an 80-takt on Ladieswear, and area is having a 100-takt. It will then show how much money you would gain in that store if you perform on a 100-takt in the store.',
    },
    areaTakt: {
      key: 'storeOverview.topPotential.areaTakt',
      defaultValue:
        "The area's takt vs LY. Takt is a measure of how many items you sell vs LY. E.g. 110-takt vs LY means that you sell 10% more items than last year.",
    },
  },
  salesPerformance: {
    title: {
      key: 'storeOverview.salesPerformance.title',
      defaultValue: 'Sales Performance',
    },
    tooltip: {
      key: 'storeOverview.salesPerformance.tooltip',
      defaultValue: `A general overview selling vs LY, PL, BU, Vs. Area & SM, on different time horizons. 
If filtered on index it will show for that specific index.`,
    },
    errorText: {
      key: 'storeOverview.salesPerformance.errorText',
      defaultValue: 'Failed to load sales performance data.',
    },
    period: {
      key: 'storeOverview.salesPerformance.period',
      defaultValue: 'Period',
    },
    selectedDay: {
      key: 'storeOverview.salesPerformance.selectedDay',
      defaultValue: 'Selected day',
    },
    currentWeek: {
      key: 'storeOverview.salesPerformance.currentWeek',
      defaultValue: 'Current Week',
    },
    salesText: {
      key: 'storeOverview.salesPerformance.salesText',
      defaultValue: 'Sales',
    },
    moneyText: {
      key: 'storeOverview.salesPerformance.moneyText',
      defaultValue: 'Money',
    },
  },
  equation: {
    title: {
      key: 'storeOverview.equation.title',
      defaultValue: 'Equation',
    },
    tooltip: {
      key: 'storeOverview.equation.tooltip',
      defaultValue: `An overview of the sales equation including its all parts, on different time horizons.
If filtered on index it will show for that index on Price/pcs, Pieces per receipt and average purchase.`,
    },
    errorText: {
      key: 'storeOverview.equation.errorText',
      defaultValue: 'Failed to load equation data.',
    },
    metric: {
      key: 'storeOverview.equation.metric',
      defaultValue: 'Metric',
    },
    traffic: {
      key: 'storeOverview.equation.traffic',
      defaultValue: 'Traffic',
    },
    conversion: {
      key: 'storeOverview.equation.conversion',
      defaultValue: 'Conversion',
    },
    pricePerPiece: {
      key: 'storeOverview.equation.pricePerPiece',
      defaultValue: 'Price/Pcs',
    },
    avgPurchase: {
      key: 'storeOverview.equation.avgPurchase',
      defaultValue: 'Avg. Purchase',
    },
    visitor: {
      key: 'storeOverview.equation.visitor',
      defaultValue: 'Rev/Visitor',
    },
  },
  salesByIndex: {
    title1: {
      key: 'storeOverview.salesByIndex.title1',
      defaultValue: 'Sales By Index',
    },
    title2: {
      key: 'storeOverview.salesByIndex.title2',
      defaultValue: 'Sales By Sub Index',
    },
    tooltip: {
      key: 'storeOverview.salesByIndex.tooltip',
      defaultValue:
        "An overview of the sales on Index Groups, Garment Groups. If filtered on index, it will show that index subidx's and departments.",
    },
    errorText: {
      key: 'storeOverview.salesByIndex.errorText',
      defaultValue: 'Error loading sales by index data',
    },
    sliderTitle1: {
      key: 'storeOverview.salesByIndex.sliderTitle1',
      defaultValue: 'Index Details',
    },
    sliderTitle2: {
      key: 'storeOverview.salesByIndex.sliderTitle2',
      defaultValue: 'Sub Index Details',
    },
  },
  salesByGarmentGroup: {
    title1: {
      key: 'storeOverview.salesByGarmentGroup.title1',
      defaultValue: 'Sales By Garment Group',
    },
    title2: {
      key: 'storeOverview.salesByGarmentGroup.title2',
      defaultValue: 'Sales By Department',
    },
    errorText: {
      key: 'storeOverview.salesByGarmentGroup.errorText',
      defaultValue: 'Error loading sales by garment group data',
    },
    sliderTitle1: {
      key: 'storeOverview.salesByGarmentGroup.sliderTitle1',
      defaultValue: 'Garment Group Details',
    },
    sliderTitle2: {
      key: 'storeOverview.salesByGarmentGroup.sliderTitle2',
      defaultValue: 'Department Details',
    },
  },
  topPlannedProducts: {
    title: {
      key: 'storeOverview.topPlannedProducts.title',
      defaultValue: 'Weekly Top Planned Products',
    },
    tooltip: {
      key: 'storeOverview.topPlannedProducts.tooltip',
      defaultValue:
        'The view where you will see the top planned products for the planning market for last completed week, and how your store is performing vs. the area and sales market and act on underperformers and understand the overperformers.',
    },
    errorText: {
      key: 'storeOverview.topPlannedProducts.errorText',
      defaultValue: 'Failed to load top planned products data.',
    },
  },
  topSoldProducts: {
    title: {
      key: 'storeOverview.topSoldProducts.title',
      defaultValue: 'Weekly Top Sold Products',
    },
    tooltip: {
      key: 'storeOverview.topSoldProducts.tooltip',
      defaultValue:
        'The view where you will see the sold products for the store for last completed week, and how your store is performing vs. the area and sales market on those products and act on underperformers and understand the overperformers.',
    },
    errorText: {
      key: 'storeOverview.topSoldProducts.errorText',
      defaultValue: 'Failed to load top sold products data.',
    },
  },
  productTableColumn: {
    subIndex: {
      key: 'storeOverview.productTableColumn.subIndex',
      defaultValue: 'Sub Index',
    },
    department: {
      key: 'storeOverview.productTableColumn.department',
      defaultValue: 'Department',
    },
    product: {
      key: 'storeOverview.productTableColumn.product',
      defaultValue: 'Product',
    },
    netSales: {
      key: 'storeOverview.productTableColumn.netSales',
      defaultValue: 'Net Sales',
    },
    pieces: {
      key: 'storeOverview.productTableColumn.pieces',
      defaultValue: 'Pieces',
    },
    price: {
      key: 'storeOverview.productTableColumn.price',
      defaultValue: 'Price',
    },
    rankingVsArea: {
      key: 'storeOverview.productTableColumn.rankingVsArea',
      defaultValue: 'Ranking vs Area',
    },
    rankingVsSalesMarket: {
      key: 'storeOverview.productTableColumn.rankingVsSalesMarket',
      defaultValue: 'Ranking vs SM',
    },
    image: {
      key: 'storeOverview.productTableColumn.image',
      defaultValue: 'Image',
    },
    details: {
      key: 'storeOverview.productTableColumn.details',
      defaultValue: 'Details',
    },
  },
  topPotential: {
    title: {
      key: 'storeOverview.topPotential.title',
      defaultValue: 'Top Potential Performance',
    },
    tooltip: {
      key: 'storeOverview.topPotential.tooltip',
      defaultValue:
        'An overview showing where you have the most potential to gain more money if you were to perform on par in takt with the area and sales market. Illustrated on Index, Garment Group and departments.',
    },
    errorText: {
      key: 'storeOverview.topPotential.errorText',
      defaultValue: 'Error loading top potential performance data.',
    },
    indexesText: {
      key: 'storeOverview.topPotential.indexesText',
      defaultValue: 'Indexes',
    },
    topPontialIndexesText: {
      key: 'storeOverview.topPotential.topPontialIndexesText',
      defaultValue: 'Top Potential Indexes',
    },
    subIndexesText: {
      key: 'storeOverview.topPotential.subIndexesText',
      defaultValue: 'SubIndexes',
    },
    topPontialSubIndexesText: {
      key: 'storeOverview.topPotential.topPontialSubIndexesText',
      defaultValue: 'Top Potential SubIndexes',
    },
    garmentGroupsText: {
      key: 'storeOverview.topPotential.garmentGroupsText',
      defaultValue: 'Garment Groups',
    },
    topPontialGarmentGroupsText: {
      key: 'storeOverview.topPotential.topPontialGarmentGroupsText',
      defaultValue: 'Top Potential Garment Groups',
    },
    departmentsText: {
      key: 'storeOverview.topPotential.departmentsText',
      defaultValue: 'Departments',
    },
    topPontialDepartmentsText: {
      key: 'storeOverview.topPotential.topPontialDepartmentsText',
      defaultValue: 'Top Potential Departments',
    },
  },
};
